// 删掉一条观点（只删观点，原文不动）：先确认，删完刷新观点、主题、关系和那一篇的观点。观点页和知识库的 AI 侧栏共用。
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App as AntApp } from 'antd'
import { unmarkClaim, type Claim } from '../../api/insights'

export function useDeleteClaim(knowledgeId?: string) {
  const qc = useQueryClient()
  const { message, modal } = AntApp.useApp()
  const remove = useMutation({
    mutationFn: (id: string) => unmarkClaim(id),
    onSuccess: () => {
      for (const key of ['insight-claims', 'insight-topics', 'insight-topic', 'insight-relations', 'doc-insights']) qc.invalidateQueries({ queryKey: [key] })
      if (knowledgeId) qc.invalidateQueries({ queryKey: ['insight-doc', knowledgeId] })
      void message.success('删掉了')
    },
    onError: (e) => void message.error(e.message),
  })
  return (c: Pick<Claim, 'id' | 'text'>) =>
    modal.confirm({
      title: '删掉这条观点？',
      content: `「${c.text.slice(0, 60)}」——只删这条观点，资料原文不受影响。`,
      okText: '删掉',
      okButtonProps: { danger: true },
      cancelText: '取消',
      onOk: () => remove.mutateAsync(c.id),
    })
}

